<template>
  <v-dialog persistent v-model="dialog" max-width="590">
    <v-card>
      <v-toolbar class="secondary-color" dark flat>
        <v-toolbar-title> Extensão de Reserva </v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-6">
        <div>
          <v-layout>
            <v-flex class="text-spacer">
              Horário marcado/previsto para o checkout:
            </v-flex>
            <v-flex>
              <span class="black--text pr-2">
                {{ item.end_date | normalizeDate }}
              </span>
            </v-flex>
          </v-layout>
          <v-layout py-2>
            <v-flex>
              <label for="model">Nova data e horário de checkout:</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1"
                    ><v-icon>mdi-calendar</v-icon></span
                  >
                </div>
                <datetime
                  class="form-control"
                  type="datetime"
                  value-zone="America/Sao_Paulo"
                  zone="America/Sao_Paulo"
                  :minute-step="10"
                  :min-datetime="minimumDate(item.end_date)"
                  v-model="new_date"
                  @input="extensionAvailability()"
                  placeholder="Selecione a data e horário..."
                ></datetime>
              </div>
            </v-flex>
          </v-layout>
          <v-layout pb-2>
            <v-flex>
              <label for="model">Valor adicional da reserva:</label>
              <div v-if="defaultExtensionValue">
                {{ extensionValue | money }}
                <a class="link" @click="defaultExtensionValue = false"
                  >Alterar valor</a
                >
              </div>
              <div v-else="defaultExtensionValue" class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1"
                    >&nbspR$&nbsp</span
                  >
                </div>
                <money
                  v-model="newExtensionValue"
                  v-bind="newExtensionValueFormat"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <label for="model">Método de pagamento:</label>
              <v-select
                width="70%"
                :items="creditCards"
                item-text="nickname"
                item-value="id"
                label="Cartão de Crédito"
                color="orange"
                prepend-inner-icon="credit_card"
                no-data-text="Nenhum cartão cadastrado"
                v-model="cardId"
                solo
                hide-details
                return-object
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="hideModal()"> Sair </v-btn>

        <v-btn
          :disabled="new_date == null || cardId == null"
          color="green darken-1"
          text
          @click="extendReservation()"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VehicleRequestController from '../../controllers/VehicleRequestController.js';
import CreditCardController from '../../controllers/UserCreditCardController';
import ExtensionController from '../../controllers/ReservationExtensionController.js';
import NumberHelper from './../../helpers/NumberHelper';

export default {
  props: {
    dialog: Boolean,
    item: Object,
  },
  data() {
    return {
      vehicleRequestController: new VehicleRequestController(this.$resource),
      creditCardController: new CreditCardController(this.$resource),
      ExtensionController: new ExtensionController(this.$resource),
      new_date: null,
      request_infos: null,
      user_id: '',
      cardId: null,
      creditCards: [],
      extensionValue: '',
      newExtensionValue: null,
      defaultExtensionValue: true,
      newExtensionValueFormat: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
    };
  },
  watch: {
    item: function () {
      this.getRequestInfo();
    },
  },
  methods: {
    minimumDate(request) {
      return moment(request).toISOString(true);
    },
    async getRequestInfo() {
      await this.vehicleRequestController.getById(this.item.id).then((res) => {
        this.user_id = res.user_id;
      });
      this.creditCards = await this.creditCardController.getAllByUserId(
        this.user_id,
        true
      );
    },
    clearForm() {
      this.new_date = null;
      this.cardId = null;
      this.extensionValue = 'R$ 0,00';
      this.newExtensionValue = null;
      this.defaultExtensionValue = true;
    },
    hideModal() {
      this.clearForm();
      this.$emit('finish');
    },
    clearFields() {},
    async extendReservation() {
      let id = this.item.id; //id da reserva
      let newDate = this.new_date; //nova data
      let card = this.cardId; // cartão
      let defaultPrice = null; // novo valor da prorrogação

      if (this.newExtensionValue) {
        defaultPrice = NumberHelper.convertMoneyToInteger(
          this.newExtensionValue
        );
      }

      await this.ExtensionController.ExtendReservation(
        id,
        newDate,
        card,
        null,
        defaultPrice
      )
        .then((res) => {
          this.$awn.success(res.message);
          this.$emit('finish');
        })
        .catch((error) => {
          //this.alert(error.body.message, 'error');
          console.log(error);
          this.$awn.alert(error.body.message);
          this.$emit('finish');
        });
    },
    async extensionAvailability() {
      let newDate = this.new_date;
      let id = this.item.id;
      await this.ExtensionController.getAdditionalExtensionValue(id, newDate)
        .then((res) => {
          this.extensionValue = parseFloat(
            res.vehicleRequestPriceInCents / 100
          ).toFixed(2);
        })
        .catch((error) => {
          console.log(error);
          this.alert(error.body.message, 'error');
        });
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    formatDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[-]MM[-]YYYY HH:mm');
    },
  },
  filters: {
    money(str) {
      if (isNaN(str)) {
        return 'R$ 0,00';
      } else {
        return 'R$ ' + str.replace('.', ',');
      }
    },
    normalizeDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM[/]YYYY [ - ] HH:mm');
    },
  },
};
</script>
<style>
.text-spacer {
  width: 10% !important;
}
.secondary-color {
  background-color: var(--secondary-color) !important;
}
</style>
